import { render, staticRenderFns } from "./AffectedSalepointsDialog.vue?vue&type=template&id=3600daf8&scoped=true&"
import script from "./AffectedSalepointsDialog.vue?vue&type=script&lang=js&"
export * from "./AffectedSalepointsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600daf8",
  null
  
)

export default component.exports